module.exports = __webpack_public_path__ + "static/quem-somos-sm-66796b4762e90eb3f06eeb87c52c9f74.png";